module.exports = __webpack_public_path__ + "img/bg.9c604983.svg";